export const ACTIVITIES_LOADED = 'set_loaded_activities';
export const LOAD_ACTIVITIES = 'load_activities';
export const SYNC_FAILED = 'activities_sync_has_failed';
